import React from 'react';
import { useLocation } from 'react-router-dom';
import config from '../config';

const MobileMenu = ({ isMobileNavOpen, toggleMobileNav, openDropdown, toggleDropdown }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Define all menu items including dropdown
  const menuItems = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About Us" },
    { 
      path: "#", 
      label: "Departments",
      submenu: [
        { path: "/applied-behavioral-analysis", label: "Applied Behavioral Analysis" },
        { path: "/speech-language-pathology", label: "Speech Language Pathology" },
        { path: "/occupational-therapy", label: "Occupational Therapy" },
        { path: "/special-eduaction", label: "Special Education" },
      
      ]
    },
    { 
      path: "#", 
      label: "Programs",
      submenu: [
        { path: "/early-intervention-program", label: "Early Intervention" },
        { path: "/school-readiness-program", label: "School Readiness" },
        { path: "/caregiver-coaching-program", label: "Caregiver Coaching" },
        { path: "/group-and-social-skills-program", label: "Group And Social Skills" },
        { path: "/parent-counselling-program", label: "Parent Counselling" },
      ]
    },
   
   { path: "/our-team", label: "Our Team" },
   { 
    path: "#", 
    label: "Beyond Therapy",
    submenu: [
      { path: "/blogs", label: "Blogs" },
      { path: "/events", label: "Events" },
      // { path: "/testimonials", label: "Testimonials" },
      { path: "/achievements", label: "Achievements" },
    ]
  },
  { 
    path: "/gallery", 
    label: "Gallery",
  },
   { 
    path: "#", 
    label: "Our Branches",
    submenu: [
      { path: "/RHCA-hosur", label: "RHCA - Hosur" },
      { path: "/RHCA-electronic-city", label: "RHCA - Electronic City" },
    ]
  },
  ];

  // Check if a path is active
  const isActive = (path) => {
    return currentPath === path;
  };

  // Check if a dropdown should be marked as active
  const isDropdownActive = (submenuItems) => {
    return submenuItems.some(item => currentPath === item.path);
  };

  return (
    <div className={`mobile-nav__wrapper ${isMobileNavOpen ? 'expanded' : ''}`}>
      <div className="mobile-nav__overlay mobile-nav__toggler" onClick={toggleMobileNav}></div>
      
      <div className="mobile-nav__content">
        <span className="mobile-nav__close mobile-nav__toggler" onClick={toggleMobileNav}>
          <i className="fa fa-times"></i>
        </span>

        <div className="logo-box">
          <a href="/" aria-label="logo image">
            <img src={`${config.baseUrl}/assets/images/rohlogo.png`} width="100" alt="" />
          </a>
        </div>
          
        <div className="mobile-nav__container">
          <ul className="main-menu__list">
            {menuItems.map((item, index) => {
              if (item.submenu) {
                return (
                  <li 
                    key={index} 
                    className={`
                      dropdown 
                      ${openDropdown === item.label.toLowerCase() ? 'expanded' : ''}
                      ${isDropdownActive(item.submenu) ? 'current' : ''}
                    `}
                  >
                    <a 
                      href={item.path}
                      className={openDropdown === item.label.toLowerCase() ? 'expanded' : ''}
                      onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown(item.label.toLowerCase());
                      }}
                    >
                      {item.label}
                      <button 
                        aria-label="dropdown toggler" 
                        className={openDropdown === item.label.toLowerCase() ? 'expanded' : ''}
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </a>
                    <ul 
                      className="sub-menu" 
                      style={{ display: openDropdown === item.label.toLowerCase() ? 'block' : 'none' }}
                    >
                      {item.submenu.map((subItem, subIndex) => (
                        <li 
                          key={subIndex} 
                          className={isActive(subItem.path) ? 'current' : ''}
                        >
                          <a href={subItem.path}>{subItem.label}</a>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              }
              return (
                <li 
                  key={index} 
                  className={isActive(item.path) ? 'current' : ''}
                >
                  <a href={item.path}>{item.label}</a>
                </li>
              );
            })}
          </ul>
        </div>

        <ul className="mobile-nav__contact list-unstyled">
          <li>
            <i className="fa fa-envelope"></i>
            <a href="mailto:rayofhope@acaindia.org">rayofhope@acaindia.org</a>
          </li>
          <li>
            <i className="fa fa-phone-alt"></i>
            <a href="tel:04344255800,878">04344-255800 (Ext.878)</a> / <a href="tel:7305989924">7305989924</a>
          </li>
        </ul>
        <div className="mobile-nav__top">
          <div className="mobile-nav__social">
             <a href="https://youtube.com/@rhca-india?si=Pu2jro4V4E-xB_l_" target='_blank'  rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                                <a href="https://www.facebook.com/rayofhopeACA?mibextid=rS40aB7S9Ucbxw6v" target='_blank'  rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
                                <a href="https://www.linkedin.com/company/ray-of-hope-center-for-autism/" target='_blank'  rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                                <a href="https://www.instagram.com/rhcahosur?igsh=dmV5ZHA2czhsNWlv" target='_blank'  rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;